import React from 'react';
import PropTypes from 'prop-types';

import UppyUploader from '@components/common/uppy/main';
import {
  formattedUppyAttachments,
  uniqueFilesByKey,
  duplicateSweetAlertOptions } from '@helpers/uppy';

class AttachmentUppy extends React.Component {
  triggerUpload = (files) => {
    const uniqFiles = uniqueFilesByKey(files, "md5hash");
    if (files.length !== uniqFiles.length) {
      window.swal(duplicateSweetAlertOptions, (removeDuplicates) => {
        if (removeDuplicates) {
          this.stageAttachmentForUpload(formattedUppyAttachments(uniqFiles));
        } else {
          this.stageAttachmentForUpload(formattedUppyAttachments(files));
        }
      });
    } else {
      this.stageAttachmentForUpload(formattedUppyAttachments(files));
    }
  }

  stageAttachmentForUpload = (attachments) => {
    const { assetKey, onUpload } = this.props;

    onUpload(attachments);
    Insight.createEvent('added_attachments', assetKey, 'asset');
  }

  trigger = () => `uppy-asset-upload-trigger-${this.props.assetKey}`

  renderArea() {
    return (
      <div id={this.trigger()} className="uppy-attachment-area">
        <p>{t("Click to add an attachment")}</p>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderArea()}
        <UppyUploader
          {...this.props}
          handleUpload={this.triggerUpload}
          uniqIdentifier={`attachment-uppy-${this.props.assetKey}`}
          button
          trigger={`#${this.trigger()}`}
        />
      </React.Fragment>
    );
  }
}

AttachmentUppy.propTypes = {
  assetKey: PropTypes.string.isRequired
};

export default AttachmentUppy;
